/* Mobile-only swipeable carousel for variant cards on collection / search grids.
   Initializes every .variant-card-carousel on the page, is idempotent, and
   re-scans when the grid is swapped out by filtering / pagination. */
(function () {
  if (window.__variantCardCarouselInit) return;
  window.__variantCardCarouselInit = true;

  var MOVE_THRESHOLD = 10; // px before we decide swipe vs scroll/tap
  var DIRECTION_RATIO = 1.2; // horizontal must beat vertical by this to count as a swipe
  var DISTANCE_RATIO = 0.18; // fraction of slide width to advance
  var VELOCITY = 0.3; // px/ms fling threshold
  var MIN_DISTANCE = 40;
  var TRANSITION_MS = 350;
  var TRANSITION_BUFFER_MS = 50;
  var MOVING_ATTR = 'data-vcc-moving';
  var ACTIVE_CLASS = 'is-active';
  var READY_ATTR = 'data-vcc-ready';

  // Shared observer: when a card scrolls near the viewport, prefetch its 2nd image
  // (low priority) so the first swipe is instant. The rest load on first touch.
  var prefetchObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting) {
                var el = entries[i].target;
                prefetchObserver.unobserve(el);
                if (el.__vccPrefetch) el.__vccPrefetch();
              }
            }
          },
          { rootMargin: '300px 0px' }
        )
      : null;

  function loadDeferredImg(img, priority) {
    var src = img.getAttribute('data-vcc-src');
    if (!src) return;
    if (priority) {
      try { img.fetchPriority = priority; } catch (e) {}
    }
    img.src = src;
    img.removeAttribute('data-vcc-src');
  }

  function initCarousel(root) {
    if (!root || root.dataset.vccInit === '1') return;
    var track = root.querySelector('.vcc-track');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if (slides.length <= 1) {
      root.dataset.vccInit = '1';
      return; // nothing to swipe
    }
    root.dataset.vccInit = '1';

    var prevBtn = root.querySelector('.vcc-prev');
    var nextBtn = root.querySelector('.vcc-next');
    var index = 0;

    // pointer state
    var dragging = false;
    var startX = 0;
    var startY = 0;
    var dx = 0;
    var dy = 0;
    var horizontal = null;
    var startTime = 0;
    var didSwipe = false;

    // ---- Intent-based image loading ----
    function loadSlide(i, priority) {
      var s = slides[i];
      if (!s) return;
      var imgs = s.querySelectorAll('img[data-vcc-src]');
      for (var k = 0; k < imgs.length; k++) loadDeferredImg(imgs[k], priority);
    }

    var allLoaded = false;
    function loadAllOnce() {
      if (allLoaded) return;
      allLoaded = true;
      for (var i = 1; i < slides.length; i++) loadSlide(i);
    }

    // Prefetch only the 2nd image when the card scrolls into view (low priority).
    root.__vccPrefetch = function () { loadSlide(1, 'low'); };
    if (prefetchObserver) {
      prefetchObserver.observe(root);
    } else {
      root.__vccPrefetch();
    }

    // Desktop: hovering a card preloads the rest so arrow clicks are instant.
    root.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'mouse') loadAllOnce();
    });

    // Percent offsets stay exact on fractional column widths; rounded px offsets
    // let a 1px strip of the neighbouring slide show at the card edge.
    function offsetFor(i, dxPx) {
      var base = -(i * 100) + '%';
      return dxPx ? 'translateX(calc(' + base + ' + ' + dxPx + 'px))' : 'translateX(' + base + ')';
    }

    function slideWidth() {
      return root.getBoundingClientRect().width || track.getBoundingClientRect().width;
    }

    // Off-screen slides are hidden at rest (see CSS) and revealed only while moving.
    var settleTimer = null;
    function setMoving(moving) {
      clearTimeout(settleTimer);
      if (moving) {
        root.setAttribute(MOVING_ATTR, '');
      } else {
        root.removeAttribute(MOVING_ATTR);
      }
    }

    function update(animate) {
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.toggle(ACTIVE_CLASS, i === index);
      }
      if (animate) {
        setMoving(true);
        track.style.transition = 'transform ' + TRANSITION_MS + 'ms ease';
        settleTimer = setTimeout(function () { setMoving(false); }, TRANSITION_MS + TRANSITION_BUFFER_MS);
      } else {
        track.style.transition = 'none';
        setMoving(false);
      }
      track.style.transform = offsetFor(index, 0);
      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index === slides.length - 1;
    }

    function onDown(e) {
      loadAllOnce(); // user intends to swipe — load remaining images now
      dragging = true;
      didSwipe = false;
      startX = e.clientX;
      startY = e.clientY;
      dx = 0;
      dy = 0;
      horizontal = null;
      startTime = Date.now();
    }

    // iOS Safari treats content revealed during a tap (hidden slides turning visible) as a
    // hover and swallows the click, so slides are only revealed once a real swipe starts.
    function startSwipe(pointerId) {
      track.style.transition = 'none';
      setMoving(true);
      try { track.setPointerCapture(pointerId); } catch (err) {}
    }

    function onMove(e) {
      if (!dragging) return;
      dx = e.clientX - startX;
      dy = e.clientY - startY;

      if (horizontal === null) {
        if (Math.abs(dx) < MOVE_THRESHOLD && Math.abs(dy) < MOVE_THRESHOLD) return;
        horizontal = Math.abs(dx) > Math.abs(dy) * DIRECTION_RATIO;
        if (!horizontal) {
          // vertical scroll — let the page take over
          dragging = false;
          return;
        }
        startSwipe(e.pointerId);
      }
      e.preventDefault();
      didSwipe = true;
      track.style.transform = offsetFor(index, dx);
    }

    function onUp(e) {
      if (!dragging) return;
      dragging = false;
      if (!horizontal) return;
      var w = slideWidth();
      var elapsed = Math.max(1, Date.now() - startTime);
      var velocity = dx / elapsed;
      var thresh = Math.max(MIN_DISTANCE, w * DISTANCE_RATIO);

      if (horizontal) {
        if (dx > thresh || velocity > VELOCITY) {
          index = Math.max(0, index - 1);
        } else if (dx < -thresh || velocity < -VELOCITY) {
          index = Math.min(slides.length - 1, index + 1);
        }
      }
      update(true);
      try { track.releasePointerCapture(e.pointerId); } catch (err) {}
    }

    track.addEventListener('pointerdown', onDown);
    track.addEventListener('pointermove', onMove, { passive: false });
    track.addEventListener('pointerup', onUp);
    track.addEventListener('pointercancel', function () {
      if (!dragging) return;
      dragging = false;
      if (horizontal) update(true);
    });

    // Swallow the click that follows a swipe so the card link doesn't navigate.
    root.addEventListener(
      'click',
      function (e) {
        if (didSwipe) {
          e.preventDefault();
          e.stopPropagation();
          didSwipe = false;
        }
      },
      true
    );

    // Arrows step through images without navigating to the product.
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        loadAllOnce();
        if (index > 0) {
          index--;
          update(true);
        }
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        loadAllOnce();
        if (index < slides.length - 1) {
          index++;
          update(true);
        }
      });
    }

    update(false);
    root.setAttribute(READY_ATTR, '');
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('.variant-card-carousel');
    for (var i = 0; i < nodes.length; i++) initCarousel(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-scan when filters / pagination swap the grid HTML.
  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      initAll();
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
